import moment from "moment";
import React, { Component } from "react";
import { getFromLocalStorage } from "./localStorage";

const timeOut = 1000 * 60 * 5; // Timeout after 5 minutes of inactivity

const protectPage = (WrappedComponent) => {
  return class WithTimeOut extends Component {
    _isMounted = false;
    // For Setting Time Out
    clearTimeoutFunc = () => {
      if (this.logoutTimeout) {
        clearTimeout(this.logoutTimeout);
      }
    };
    setTimeout = () => {
      this.logoutTimeout = setTimeout(this.logout, timeOut);
    };
    resetTimeout = () => {
      this.clearTimeoutFunc();
      this.setTimeout();
    };

    removeAllModals = () => {
      const modals = Array.from(document.querySelectorAll(".modal-backdrop"));

      // Close all boostrap modals
      if (modals.length) {
        modals.map((modal) => (modal.style.display = "none"));
      }

      // Close major modal
      const majorModal = document.querySelector("#Modal__close");
      const majorModalContainer = document.querySelector("#myModal");
      if (majorModal) {
        majorModal.click();
      }
      if (majorModalContainer) {
        majorModalContainer.style.display = "none";
      }
    };

    logout = () => {
      this.removeAllModals();
      localStorage.clear();
      if (this._isMounted && this.props.history.push) {
        this.props.history.push("/logout");
        alert("Your session timed out");
      }
    };

    // Check if user token is still valid
    isTokenActive = () => {
      const expiryTime = getFromLocalStorage("expiryTime");

      if (!expiryTime) {
        this.removeAllModals();
        localStorage.clear();
        return this.props.history.push("/logout");
      }

      const currentTime = moment().format();
      // Token will expire if the currentTime is after expiryTime
      const hasTokenExpired = moment(currentTime).isAfter(expiryTime);
      if (hasTokenExpired) {
        this.logout();
      }
    };

    // Cancelling subscriptions
    componentWillUnmount() {
      this._isMounted = false;
    }

    componentDidMount = async () => {
      this._isMounted = true;

      // Check if token is still active.
      this.isTokenActive();

      // Handling timeout when there is no event
      this.events = [
        "load",
        "mousemove",
        "mousedown",
        "click",
        "scroll",
        "keypress",
      ];

      for (var i in this.events) {
        window.addEventListener(this.events[i], this.resetTimeout);
      }
      this.setTimeout(); //End of Timeout handling
    };

    componentDidUpdate(nextProps) {
      if (nextProps.location !== this.props.location) {
        // Check if token is still active whenever user changes route
        this.isTokenActive();
      }
    }

    render() {
      return (
        <div className="p-3" style={{ minHeight: "90vh" }}>
          <WrappedComponent />
        </div>
      );
    }
  };
};

export default protectPage;
